import { Injectable } from '@angular/core';
import { Config } from '../../models/config';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  config: Config | null = null;
}
